export default class ActionLogListController {

    constructor(ActionLogEntries) {
        this.store = ActionLogEntries;
    }
}

ActionLogListController.$inject = [
    'ActionLogEntries'
];



// WEBPACK FOOTER //
// ./src/app/modules/action_log/controller/list-controller.js